import React from "react";
import { Link } from "react-router-dom";
import siteConfig, { formatCurrency } from "../config/siteConfig";
import "../css/about.scss";

const questions = [
  ["How much is delivery?", `Tracked standard delivery is ${formatCurrency(siteConfig.flatShippingRate)} per order. The final total is shown before you continue to payment.`],
  ["When will my order be dispatched?", "In-stock items are usually prepared within one to two business days. Tracking is sent by email after the parcel is accepted by the carrier."],
  ["Can I change my delivery address?", "Email us as soon as possible. We can correct an address before dispatch, but changes are not guaranteed after a parcel enters the carrier network."],
  ["What is your return window?", "Eligible unused products in their original packaging may be returned within 30 days of delivery. Opened inks, paints, markers, adhesives, and personalized goods cannot be returned."],
  ["Are the product photographs exact?", "We photograph or commission imagery to represent each item accurately. Natural materials and screen settings can cause small differences in grain, texture, and color."],
  ["How is payment handled?", "After you submit your contact and delivery details, you are redirected to our secure payment partner. ierryhouse does not ask for card details on the checkout form."],
];

const FAQs = () => (
  <main className="editorial-page policy-page">
    <div className="editorial-page__inner">
      <header className="editorial-page__hero">
        <p className="editorial-page__eyebrow">Customer care</p>
        <h1>Frequently asked questions</h1>
        <p className="editorial-page__lede">Clear answers about ordering, delivery, returns, products, and payment.</p>
      </header>
      {questions.map(([question, answer], index) => (
        <section className="policy-section" key={question}>
          <p className="editorial-page__section-label">{String(index + 1).padStart(2, "0")}</p>
          <h2>{question}</h2>
          <p>{answer}</p>
        </section>
      ))}
      <aside className="policy-demo-note">
        <h2>Still need help?</h2>
        <p>Visit our <Link to="/contact">contact page</Link> or email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.</p>
      </aside>
    </div>
  </main>
);

export default FAQs;
